export class ScrollAnimatedElement {
  constructor(element) {
    this.element = element;
    this.number = 0;
    this.temp = 0;
    this.timer = null;
    
    this.targetnumber = parseInt(element.getAttribute('data-target')) || 100;


    this.speed = ((parseInt(element.getAttribute('data-speed')) || 2) * 1000) / this.targetnumber;

    //console.log(this.duration, this.targetnumber, this.speed)
    this.increment = 1;
    this.reset = element.getAttribute('data-reset');

    this.initEvents();
  }

  initEvents() {
    window.addEventListener('load',   () => this.run());
    window.addEventListener('resize', () => this.run());
    window.addEventListener('scroll', () => this.run());
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  run() {
    if (this.isInViewport(this.element)) {
      if (!this.element.classList.contains('showinview')) {
        this.number = 0;
        this.temp = 0;
        this.resetDisplay();
        this.element.classList.add('showinview');
        if (!this.timer) {
          this.timer = setInterval(() => this.update(), this.speed); 
        }
      }
    } else {
      if (this.reset) {
        clearInterval(this.timer);
        this.timer = null;
        this.element.classList.remove('showinview');
        this.number = 0;
        this.temp = 0;
        this.resetDisplay();
      }
    }
  }

  // Override in subclass
  update() {}
  resetDisplay() {}
}
